export class MockAnalytics {
    track(_trigger, _section, _label, _data) {
        // console.log('##### TRACK', trigger, section, label, data)
        // noop
    }
}
//# sourceMappingURL=MockAnalytics.js.map